import { useCookies } from "react-cookie";
const currentPublisher = JSON.parse(localStorage.getItem("Current-Publisher"));

export function useAxiosConfigGlobal() {
  const [cookie] = useCookies();
  const axiosConfig = {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + cookie.mmusic_token,
      "Publisher-Id": JSON.parse(localStorage.getItem("Current-Publisher"))?.id,
      "Content-Type": "application/json",
      "Current-Song-Ids": localStorage.getItem("Current-Song-Ids"),
      "Current-Album-Ids": localStorage.getItem("Current-Album-Ids"),
      "Current-Artist-Ids": localStorage.getItem("Current-Artist-Ids"),
      "Current-Single-Ids": localStorage.getItem("Current-Single-Ids"),
    },
  };

  return axiosConfig;
}
export function useAxiosKaraokeConfigGlobal() {
  const [cookie] = useCookies();
  return {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + cookie.mmusic_token,
      "Publisher-Id": JSON.parse(localStorage.getItem("Current-Publisher"))?.id,
      "Content-Type": "application/json",
      "Karaoke-Artist-Ids": localStorage.getItem("Karaoke-Artist-Ids"),
      "Karaoke-Song-Ids": localStorage.getItem("Karaoke-Song-Ids"),
      "Karaoke-Artist-Songs": localStorage.getItem("Karaoke-Artist-Songs"),
    },
  };
}

export function usePasswordAxiosConfig() {
  const [cookie] = useCookies();
  const axiosConfig = {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + cookie.mmusic_token,
      "Publisher-Id": JSON.parse(localStorage.getItem("Current-Publisher"))?.id,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  return axiosConfig;
}

export const EmailHeader = {
  model: {
    id: currentPublisher?.id,
    type: currentPublisher?.is_label === 1 ? "publisher" : "artist",
  },
  requested: currentPublisher?.email,
  current_publisher: {
    name: currentPublisher?.name,
    cover: currentPublisher?.cover,
  },
  attributes: [],
};
